import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddLocation from "./addLocation";
import GetAllLocation from "./getAllLocation";

const Location = () => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [modalOpen, setModalOpen] = useState(false);

  if (!isLogged) {
    return <Navigate to="/auth/login" replace={true} />;
  }

  const handleSuccess = () => {
    setModalOpen(false);
  };

  const addLocationButton = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setModalOpen(true)}
      style={{
        background: "#52c41a",
        borderColor: "#52c41a",
        fontWeight: 600,
      }}
    >
      Add Location
    </Button>
  );

  return (
    <div>
      <Modal
        title="Add Location"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <AddLocation
          inModal
          onSuccess={handleSuccess}
          onCancel={() => setModalOpen(false)}
        />
      </Modal>
      <GetAllLocation addLocationButton={addLocationButton} />
    </div>
  );
};

export default Location;
